<template>
    <div class="dp-fx fx-al-ct fx-js-ct br-rd-pr-50 comment-bttn wd-ht-px-50 cs-ptr" v-on:click="$emit('comment-button-clicked')">
        <img src="@/assets/comment.png" height=22 alt="Comment Icon"/>
    </div>
</template>

<script>
    export default {
        name : 'CommentButton',
        data : function () {
            return {}
        },
        methods : {}
    }
</script>

<style lang="scss">
    .wd-ht-px-60{
        width: 60px;
        height: 60px;
    }
    .wd-ht-px-50{
        width: 50px;
        height: 50px;
    }
    .comment-bttn{
        background-color: #a6a6a6;
        color: #ffffff;
    }
</style>